<template>
    <b-modal id="reset-password-modal" modal-class="account-modal" title="忘记密码" hide-footer>
        <div class="modal-bar">
            <b-form>
                <mobile-coder :form="resetPasswordForm"/>
                <repeat-password :form="resetPasswordForm"/>
                <b-form-group label-cols="3">
                    <b-btn variant="primary">修改密码</b-btn>
                </b-form-group>
            </b-form>
            <div>
                <p>去<a href="javascript:" v-b-modal:login-modal @click="hideResetPasswordModal">登录</a></p>
            </div>
        </div>
    </b-modal>
</template>

<script>
import MobileCoder from "cps/data/MobileCoder";
import RepeatPassword from "cps/data/RepeatPassword";
export default {
    name: "ResetPasswordAlert",
    components: {RepeatPassword, MobileCoder},
    data() {
        return {
            resetPasswordForm: {
                mobile: '',
                code: '',
                newPassword: '',
                repeatPassword: ''
            }
        }
    },
    methods: {
        hideResetPasswordModal() {
            this.$bvModal.hide('reset-password-modal');
        },
    }
}
</script>

<style scoped>

</style>